export default __webpack_public_path__ + "static/media/KIRANKUMAR_B_G.81de4e5f.JPG";